import {
    Badge,
    Box,
    Container,
    IconButton,
    Typography,
    TextField,
    InputAdornment,
    Card,
    CardContent,
    Stack,
    useTheme,
    useMediaQuery,
    Fade,
    alpha,
    Button
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
    AddCircle,
    NotificationsActiveOutlined,
    WorkOutlineOutlined,
    EventNoteOutlined,
    AddBox,
    QrCode2 as QrCode2Icon,
    CropFree as CropFreeIcon,
    Search as SearchIcon,
    Edit as EditIcon
} from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useDispatch, useSelector } from "react-redux";
import {
    getNotificationList,
    getActiveCounts,
    getAutonomousActiveCounts,
    getBarCodeContext
} from "../../store/actions/OperatorMainPageActions";
import { qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";

export default function OperatorMainPage(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const [userName, setUserName] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [connection, setConnection] = useState(null);
    const [qrOpen, setQrOpen] = useState(false);
    const [barcodeOpen, setBarcodeOpen] = useState(false);
    const [state, setState] = useState({ result: "No result" });
    const [requestNumber, setRequestNumber] = useState(0);
    const [activeAutonomousOrder, setActiveAutonomousOrder] = useState(null);
    const [activeAutonomousOrderCreatedByUser, setActiveAutonomousOrderCreatedByUser] = useState(null);

    const { t } = useTranslation("translation");
    const qrRef = useRef();
    let executedScroll = false;

    const { notifications, unPlannedActiveCounts, autonomousActiveCounts, barCodeInfo } = useSelector(
        ({ operatorPage }) => operatorPage
    );

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserName(oktaToken.idToken.claims.name);
        LoadData();

        const timer = setInterval(() => {
            GetNotificationCount();
        }, 10000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then((result) => {
                    connection.on("UpdateNotificationCount", (user) => {
                        let username = GetUsername();
                        if (user === username) {
                            GetNotificationCount();
                        }
                    });
                })
                .catch((err) => {});
        }
    }, [connection]);

    useEffect(() => {
        if (notifications?.resultObject) {
            setNotificationCount(notifications.resultObject.length);
        }
    }, [notifications]);

    useEffect(() => {
        if (unPlannedActiveCounts?.resultObject) {
            setRequestNumber(unPlannedActiveCounts.resultObject.activeOrderCreatedByUser);
            setPageLoaded(true);
            dispatch(getAutonomousActiveCounts());
        }
    }, [unPlannedActiveCounts]);

    useEffect(() => {
        if (autonomousActiveCounts?.resultObject) {
            console.log(autonomousActiveCounts.resultObject);
            setActiveAutonomousOrderCreatedByUser(autonomousActiveCounts.resultObject.activeTaskAssigneeToUser);
            setActiveAutonomousOrder(autonomousActiveCounts.resultObject.activeOrder);
            setPageLoaded(true);
        }
    }, [autonomousActiveCounts]);

    useEffect(() => {
        if (barCodeInfo?.resultObject) {
            props.history.push("/reportbreakdown?id=" + barCodeInfo?.resultObject.id + "&name=" + barCodeInfo?.resultObject.name);
            setQrOpen(false);
        }
        barCodeInfo.resultObject = null;
    }, [barCodeInfo]);

    const OpenAutonomousMaintenanceTaskListPage = () => {
        props.history.push("/autonomous-maintenance-list");
    };

    const LoadData = () => {
        dispatch(getActiveCounts());
        GetNotificationCount();
    };

    const GetNotificationCount = () => {
        dispatch(getNotificationList(GetUsername()));
    };

    const GetUsername = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        return oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
    };

    const OpenNotificationList = () => {
        props.history.push("/notificationlist");
    };

    const ReportBreakdownPage = () => {
        props.history.push("/reportbreakdown?from=operator");
    };

    const OperatorRequestsPage = () => {
        props.history.push("/operatorrequests");
    };

    const HandleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, result: data });
            dispatch(getBarCodeContext(data));
        }
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            dispatch(getBarCodeContext(e.target.value));
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        dispatch(getBarCodeContext(state.result));
    };

    const MainActionButton = ({ icon: Icon, label, onClick, color }) => (
        <Button
            variant="contained"
            onClick={onClick}
            startIcon={
                <Icon 
                    sx={{ 
                        fontSize: isMobile ? '1.5rem' : '1.75rem',
                        transition: 'transform 0.2s ease',
                        transform: 'translateX(-4px)'
                    }} 
                />
            }
            sx={{
                bgcolor: 'background.paper',
                color: color || theme.palette.primary.main,
                borderRadius: 2.5,
                py: isMobile ? 1.5 : 2,
                px: 2,
                width: '100%',
                justifyContent: 'center',
                border: `1px solid ${alpha(color || theme.palette.primary.main, 0.12)}`,
                background: `linear-gradient(135deg, ${alpha(color || theme.palette.primary.main, 0.08)} 0%, ${alpha(color || theme.palette.primary.main, 0.02)} 100%)`,
                boxShadow: `0 4px 12px ${alpha(color || theme.palette.primary.main, 0.1)}`,
                fontWeight: 500,
                textTransform: 'none',
                fontSize: isMobile ? '0.875rem' : '0.95rem',
                '&:hover': {
                    bgcolor: alpha(color || theme.palette.primary.main, 0.08),
                    transform: 'translateY(-2px)',
                    boxShadow: `0 8px 20px ${alpha(color || theme.palette.primary.main, 0.15)}`,
                    '& .MuiSvgIcon-root': {
                        transform: 'translateX(-4px) scale(1.1)',
                    }
                },
                '&:active': {
                    transform: 'translateY(0)',
                    boxShadow: `0 4px 12px ${alpha(color || theme.palette.primary.main, 0.1)}`,
                },
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
            }}
        >
            {label}
        </Button>
    );

    const ActionButton = ({ icon: Icon, label, count, color, onClick }) => (
        <Card 
            sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                background: isMobile ? 
                    `linear-gradient(135deg, ${alpha(color || theme.palette.primary.main, 0.08)} 0%, ${alpha(color || theme.palette.primary.main, 0.03)} 100%)` : 
                    'background.paper',
                border: `1px solid ${alpha(color || theme.palette.primary.main, 0.1)}`,
                borderRadius: isMobile ? 3 : 1,
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                    background: isMobile ? 
                        `linear-gradient(135deg, ${alpha(color || theme.palette.primary.main, 0.12)} 0%, ${alpha(color || theme.palette.primary.main, 0.05)} 100%)` : 
                        'background.paper',
                }
            }}
            onClick={onClick}
        >
            <CardContent sx={{ p: isMobile ? 1.5 : 2 }}>
                <Stack spacing={1} alignItems="center">
                    <Badge 
                        badgeContent={count} 
                        sx={{
                            '& .MuiBadge-badge': {
                                backgroundColor: color || theme.palette.primary.main,
                                color: theme.palette.common.white,
                                fontWeight: 600,
                                minWidth: 20,
                                height: 20
                            }
                        }}
                    >
                        <Icon 
                            sx={{ 
                                width: isMobile ? 32 : 48, 
                                height: isMobile ? 32 : 48,
                                color: color || theme.palette.primary.main,
                                transition: 'transform 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.1)'
                                }
                            }} 
                        />
                    </Badge>
                    <Typography 
                        variant="body2" 
                        color="text.secondary"
                        align="center"
                        sx={{ 
                            fontSize: isMobile ? '0.7rem' : '0.875rem',
                            fontWeight: 500,
                            lineHeight: 1.2
                        }}
                    >
                        {label}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    );

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 3}}>
            {pageLoaded && (
                <Container maxWidth="sm" sx={{ px: isMobile ? 1 : 3}}>
                    <Stack spacing={isMobile ? 2 : 3}>
                        {/* Header */}
                        <Card 
                            sx={{ 
                                bgcolor: 'primary.main',
                                color: 'primary.contrastText',
                                borderRadius: isMobile ? 3 : 1,
                                boxShadow: isMobile ? `0 4px 20px ${alpha(theme.palette.primary.main, 0.25)}` : theme.shadows[2]
                            }}
                        >
                            <CardContent sx={{ py: isMobile ? 1.5 : 2 }}>
                                <Typography 
                                    variant={isMobile ? "subtitle1" : "h6"} 
                                    align="center"
                                    sx={{ fontWeight: isMobile ? 500 : 400 }}
                                >
                                    {userName}
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* Quick Actions */}
                        <Grid container spacing={isMobile ? 1.5 : 2}>
                            <Grid xs={4}>
                                <ActionButton
                                    icon={NotificationsActiveOutlined}
                                    label={t("Notifications")}
                                    count={notificationCount}
                                    color={theme.palette.warning.main}
                                    onClick={OpenNotificationList}
                                />
                            </Grid>
                            <Grid xs={4}>
                                <ActionButton
                                    icon={WorkOutlineOutlined}
                                    label={t("MyOrders")}
                                    count={requestNumber}
                                    color={theme.palette.info.main}
                                    onClick={OperatorRequestsPage}
                                />
                            </Grid>
                            <Grid xs={4}>
                                <ActionButton
                                    icon={EventNoteOutlined}
                                    label={t("AutonomousMaintenanceTaskList")}
                                    count={`${activeAutonomousOrderCreatedByUser}/${activeAutonomousOrder}`}
                                    color={theme.palette.success.main}
                                    onClick={OpenAutonomousMaintenanceTaskListPage}
                                />
                            </Grid>
                        </Grid>

                        {/* Main Actions */}
                        <Card 
                            sx={{ 
                                borderRadius: isMobile ? 3 : 1.5,
                                background: isMobile ? 
                                    `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)` : 
                                    'background.paper',
                                boxShadow: isMobile ? 
                                    `0 8px 32px ${alpha(theme.palette.primary.main, 0.08)}` : 
                                    theme.shadows[2]
                            }}
                        >
                            <CardContent sx={{ p: isMobile ? 2 : 3 }}>
                                <Stack spacing={3}>
                                    <Box>
                                        <Typography 
                                            variant="subtitle1" 
                                            color="text.primary"
                                            sx={{ 
                                                mb: 0.5, 
                                                fontWeight: 600,
                                                fontSize: isMobile ? '1rem' : '1.1rem'
                                            }}
                                        >
                                            {t("OpenBreakdownRequest")}
                                        </Typography>
                                    </Box>
                                    
                                    <Grid container spacing={2} >
                                        <Grid xs={4} sx={{display: "flex"}}>
                                            <MainActionButton
                                                icon={EditIcon}
                                                label={t("Manual")}
                                                onClick={ReportBreakdownPage}
                                                color={theme.palette.secondary.main}
                                            />
                                        </Grid>
                                        <Grid xs={4}>
                                            <MainActionButton
                                                icon={QrCode2Icon}
                                                label={t("QR")}
                                                onClick={() => setQrOpen(true)}
                                                color={theme.palette.primary.main}
                                            />
                                        </Grid>
                                        <Grid xs={4}>
                                            <MainActionButton
                                                icon={CropFreeIcon}
                                                label={t("Barcode")}
                                                onClick={() => setBarcodeOpen(true)}
                                                color={theme.palette.primary.main}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Box sx={{ 
                                        pt: 1,
                                        borderTop: `1px solid ${alpha(theme.palette.divider, 0.08)}`
                                    }}>
                                        <MainActionButton
                                            icon={AddBox}
                                            label={t("OpenScheduledMaintenance")}
                                            onClick={() => props.history.push("/create-planned-maintenance?from=operator")}
                                            color={theme.palette.info.main}
                                        />
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>

                        {/* QR Scanner */}
                        <Fade in={qrOpen}>
                            <Card 
                                sx={{ 
                                    display: qrOpen ? 'block' : 'none',
                                    borderRadius: isMobile ? 3 : 1,
                                    overflow: 'hidden',
                                    boxShadow: isMobile ? theme.shadows[8] : theme.shadows[2]
                                }}
                            >
                                <CardContent sx={{ p: isMobile ? 1 : 2 }}>
                                    <div ref={qrRef}>
                                        <QrReader
                                            scanDelay={500}
                                            onResult={HandleScan}
                                            constraints={{ facingMode: "environment" }}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </Fade>

                        {/* Barcode Scanner */}
                        <Fade in={barcodeOpen}>
                            <Card 
                                sx={{ 
                                    display: barcodeOpen ? 'block' : 'none',
                                    borderRadius: isMobile ? 3 : 1,
                                    overflow: 'hidden'
                                }}
                            >
                                <CardContent sx={{ p: isMobile ? 2 : 3 }}>
                                    <TextField
                                        fullWidth
                                        autoFocus
                                        placeholder={t("ScanBarcode")}
                                        onChange={HandleScanBarcode}
                                        onKeyDown={handleKeypress}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: isMobile ? 2 : 1,
                                                '& fieldset': {
                                                    borderColor: alpha(theme.palette.primary.main, 0.2),
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: alpha(theme.palette.primary.main, 0.3),
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton 
                                                        edge="end" 
                                                        color="primary" 
                                                        onClick={handleSubmit}
                                                        sx={{
                                                            '&:hover': {
                                                                transform: 'scale(1.1)',
                                                            },
                                                            transition: 'transform 0.2s ease'
                                                        }}
                                                    >
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </Fade>
                    </Stack>
                </Container>
            )}
            <LoadingBackdrop />
        </Box>
    );
}
